/**
 * 关于时间, 日期的方法函数
 */

/**
 * 格式化时间
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符,
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * @param { int } timestamp 时间戳（毫秒计）
 * @param { string } format 格式
 * @returns { string } 格式化后的日期
 * @example
 * timeFormat(new Date(), 'yyyy-MM-dd hh:mm:ss.S') ==> 2006-07-02 08:09:04.423
 * timeFormat(new Date(), 'yyyy-M-d h:m:s.S')      ==> 2006-7-2 8:9:4.18
 * timeFormat(new Date(), 'yyyy-MM-dd')      ==> 2006-07-02
 * timeFormat(new Date(), 'MM-dd hh:mm')      ==> 07-02 08:09
 * timeFormat(new Date(), 'MM/dd hh:mm')      ==> 07/02 08:09
 */
export function timeFormat(timestamp, format) {
	let date = new Date(Number(timestamp));
	let o = {
		'M+': date.getMonth() + 1, // 月份
		'd+': date.getDate(), // 日
		'h+': date.getHours(), // 小时
		'm+': date.getMinutes(), // 分
		's+': date.getSeconds(), // 秒
		'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
		S: date.getMilliseconds() // 毫秒
	};

	if (/(y+)/.test(format)) {
		format = format.replace(
			RegExp.$1,
			(date.getFullYear() + '').substr(4 - RegExp.$1.length)
		);
	}

	for (let k in o) {
		if (new RegExp('(' + k + ')').test(format)) {
			format = format.replace(
				RegExp.$1,
				RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
			);
		}
	}
	return format;
}

/**
 * 毫秒转换友好的显示格式
 * 输出格式：21小时前、3天前、刚刚、 5分钟前
 * @param { int } timestamp 时间戳（毫秒计）
 * @returns { string } 返回格式化后的时间
 */
export function timeAgo(timestamp) {
	// 把分，时，天用毫秒表示
	const minute = 60 * 1000;
	const hour = minute * 60;
	const day = hour * 24;

	let now = new Date().getTime(); //获取当前时间毫秒
	let diff = now - timestamp; //时间差
	if (diff < 0) {
		return;
	}
	// 计算时间差
	let minDiff = parseInt(diff / minute);
	let hourDiff = parseInt(diff / hour);

	if (diff < minute) {
		return '刚刚';
	} else if (diff < hour) {
		return `${minDiff}分钟前`;
	} else if (diff < day) {
		return `${hourDiff}小时前`;
	} else if (isYestday(timestamp)) {
		return '昨天 ' + formatDateTime(timestamp).substr(11, 5);
	} else if (isThisYear(timestamp)) {
		return formatDateTime(timestamp).slice(5, -3);
	} else {
		return formatDateTime(timestamp).slice(0, -3);
	}
}

/**
 * 判断是时间戳是否为昨天
 * @param { int } timestamp
 * @returns { boolean }
 */
export function isYestday(timestamp) {
	// 当前时间
	let date = new Date();
	// 今天凌晨
	let today = new Date(
		date.getFullYear(),
		date.getMonth(),
		date.getDate()
	).getTime();
	let yestday = new Date(today - 24 * 3600 * 1000).getTime();
	return timestamp < today && yestday <= timestamp;
}
/**
 * 判断是时间戳是否为今天
 * @param { int } timestamp
 * @returns { boolean }
 */
export function isToday(timestamp) {
	return new Date(timestamp).toDateString() === new Date().toDateString();
}

/**
 * 判断是时间戳是否为今年
 * @param { int } timestamp
 * @returns { boolean }
 */
export function isThisYear(timestamp) {
	// 当前时间的年份
	let takeNewYear = formatDateTime(new Date()).substr(0, 4);
	// 传入时间的年份
	let takeTimeValue = formatDateTime(timestamp).substr(0, 4);
	if (takeNewYear === takeTimeValue) {
		return true;
	} else {
		return false;
	}
}

/**
 * 比较时间戳并转换日期
 * @param { number } timestamp1
 * @param { number } timestamp2
 * @param { number } d-value
 * @returns { string } 返回格式化的时间格式
 */
export function timestampFormate(timestamp1, timestamp2, dValue) {
	let timeDiffer = Math.abs(timestamp2 - timestamp1); // 与当前时间误差
	let time = '';

	if (timeDiffer > dValue) {
		// 今日
		if (isToday(timestamp2)) {
			time = formatDateTime(timestamp2).substr(11, 5);
			// 昨天
		} else if (isYestday(timestamp2)) {
			time = '昨天 ' + formatDateTime(timestamp2).substr(11, 5);
			// 今年
		} else if (isThisYear(timestamp2)) {
			time = formatDateTime(timestamp2).slice(5, -3);
			// 不属于今年
		} else if (!isThisYear(timestamp2)) {
			time = formatDateTime(timestamp2).slice(0, -3);
		}
	} else {
		time = '';
	}
	return time;
}
/**
 * 时间戳转换日期 (yyyy-MM-dd HH:mm:ss)
 * @param { number } timestamp
 * @returns { string } 格式化后的日期
 */
function formatDateTime(timestamp) {
	let date = new Date(timestamp);
	let y = date.getFullYear();
	let m = date.getMonth() + 1;
	m = m < 10 ? '0' + m : m;
	let d = date.getDate();
	d = d < 10 ? '0' + d : d;
	let h = date.getHours();
	h = h < 10 ? '0' + h : h;
	let minute = date.getMinutes();
	let second = date.getSeconds();
	minute = minute < 10 ? '0' + minute : minute;
	second = second < 10 ? '0' + second : second;
	return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second;
}

// 三个月前的时间
export function threeDate() {
	let date = new Date();
	let currentY = date.getFullYear();
	// 三个月前的时间减2
	let currentM = date.getMonth() - 2;
	let lastM = new Date(currentY, currentM, 0);
	// 日期小于10，前面加10
	let lastDay = lastM.getDate() < 10 ? '0' + lastM.getDate() : lastM.getDate();
	// 对特殊月份1,2,3,进行特殊判断
	let d = new Date();
	let realYear = null;
	// 年份应该减1
	if (d.getMonth() == 0 || d.getMonth() == 1 || d.getMonth() == 2) {
		realYear = d.getFullYear() - 1;
	} else {
		realYear = d.getFullYear();
	}
	let realMonth = null;
	// 3月对应12月，2月对应11月，1月对应10月
	if (d.getMonth() - 2 == 0) {
		realMonth = 12;
	} else if (d.getMonth() - 2 == -1) {
		realMonth = 11;
	} else if (d.getMonth() - 2 == -2) {
		realMonth = 10;
	} else {
		realMonth = d.getMonth() - 2;
	}
	// a是当前日期，lastDay是三个月前日期
	let a = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
	realMonth = realMonth < 10 ? '0' + realMonth : realMonth;
	// 当前时间大于三个月前，时间取三个月前的时间，小于或者等于，取当前时间
	let realDay = a > lastDay ? lastDay : a;
	// 返回三个月前日期
	return realYear + '-' + realMonth + '-' + realDay;
}
